module.exports = __webpack_public_path__ + "static/media/Mica.d7ab635e.jpg";